if (!customElements.get('collection-filters')) {
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const tag = event.target.closest('.collection-filters__tag');
      if (tag && this.contains(tag)) {
        event.preventDefault();
        this.onTagClick(tag);
        return;
      }

      const button = event.target.closest('[data-filter-category]');
      if (!button || !this.contains(button)) return;

      event.preventDefault();
      const category = button.dataset.filterCategory;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const current = this.dataset.openCategory;

      if (category === 'all') {
        this.removeAttribute('data-explicit-tags');
        this.setOpenCategory('all');
        this.clearOtherGroups(null);
        this.submitFilters();
        return;
      }

      if (isMobile && current === category && !this.hasAttribute('data-collapsed')) {
        this.setAttribute('data-collapsed', '');
        this.syncPanels();
        return;
      }

      if (!isMobile && current === category) return;

      this.removeAttribute('data-collapsed');
      this.removeAttribute('data-explicit-tags');
      this.setOpenCategory(category);
      this.clearOtherGroups(null);
      this.selectAllInGroup(this.groupPanel(category));
      this.submitFilters();
    }

    onTagClick(tag) {
      const input = tag.querySelector('input[type="checkbox"]');
      if (!input || input.disabled) return;

      const panel = tag.closest('[data-filter-group]');
      if (!panel) return;

      const explicit = this.hasAttribute('data-explicit-tags');

      if (!explicit) {
        this.setGroupInputs(panel, [input]);
        this.setAttribute('data-explicit-tags', '');
        this.submitFilters();
        return;
      }

      input.checked = !input.checked;
      const selected = [...panel.querySelectorAll('input[type="checkbox"]:checked')];

      if (selected.length === 0) {
        this.selectAllInGroup(panel);
        this.removeAttribute('data-explicit-tags');
      } else {
        this.syncTagVisuals(panel);
      }

      this.submitFilters();
    }

    groupPanel(category) {
      return [...this.querySelectorAll('[data-filter-group]')].find(
        (panel) => panel.dataset.filterGroup === category
      );
    }

    selectableInputs(panel) {
      if (!panel) return [];
      return [...panel.querySelectorAll('input[type="checkbox"]')];
    }

    selectAllInGroup(panel) {
      this.setGroupInputs(panel, 'all');
    }

    setGroupInputs(panel, which) {
      if (!panel) return;
      const inputs = this.selectableInputs(panel);
      const keep = which === 'all' ? null : new Set(which);

      inputs.forEach((input) => {
        const shouldCheck = keep ? keep.has(input) : true;
        if (shouldCheck) {
          input.disabled = false;
          input.removeAttribute('disabled');
          input.closest('.collection-filters__tag')?.classList.remove('is-disabled');
        }
        input.checked = shouldCheck;
      });

      this.syncTagVisuals(panel);
    }

    syncTagVisuals(panel) {
      const explicit = this.hasAttribute('data-explicit-tags');
      const scope = panel ? [panel] : this.querySelectorAll('[data-filter-group]');

      scope.forEach((group) => {
        group.querySelectorAll('.collection-filters__tag').forEach((tag) => {
          const input = tag.querySelector('input[type="checkbox"]');
          tag.classList.toggle('is-active', Boolean(explicit && input?.checked));
        });
      });
    }

    setOpenCategory(category) {
      this.dataset.openCategory = category;
      this.syncPanels();
    }

    syncPanels() {
      const openCategory = this.dataset.openCategory || 'all';
      const collapsed = this.hasAttribute('data-collapsed');

      this.querySelectorAll('[data-filter-category]').forEach((button) => {
        const isActive = button.dataset.filterCategory === openCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (button.dataset.filterCategory !== 'all') {
          button.setAttribute('aria-expanded', isActive && !collapsed ? 'true' : 'false');
        }
      });

      this.querySelectorAll('[data-filter-group]').forEach((panel) => {
        const show = panel.dataset.filterGroup === openCategory && openCategory !== 'all' && !collapsed;
        panel.classList.toggle('is-hidden', !show);
        panel.hidden = !show;
      });

      this.syncTagVisuals();
    }

    clearOtherGroups(keepGroup) {
      this.querySelectorAll('[data-filter-group]').forEach((panel) => {
        if (keepGroup && panel.dataset.filterGroup === keepGroup) return;
        panel.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false;
        });
        this.syncTagVisuals(panel);
      });
    }

    submitFilters() {
      const facetForm = this.querySelector('facet-filters-form');
      const form = this.querySelector('form');
      if (!facetForm || !form || typeof facetForm.debouncedOnSubmit !== 'function') return;

      facetForm.debouncedOnSubmit({
        preventDefault() {},
        stopPropagation() {},
        target: form,
        currentTarget: form,
        srcElement: { className: '' },
        type: 'input',
      });
    }
  }

  customElements.define('collection-filters', CollectionFilters);
}
